<template>
  <el-container v-loading="isLoad">
    <el-header style="position: fixed; right: 15px; top: 15px">
      <el-row>
        <el-button style="float: right" type="warning" @click="print">打印</el-button>
      </el-row>
    </el-header>
    <el-main>
      <div id="print">
        <div style="margin:15pt auto 10pt auto; orphans:0; text-align:center; widows:0">
          <span style="font-family:外交小标宋; font-size:16pt; font-weight:bold">因公临时出国团组执行中央八项规定及其实施细则精神报告表</span>
        </div>
        <div style="text-align:center;page-break-after: always;">
          <p style="orphans:0; text-align:left; widows:0;font-family:外交小标宋;font-size:12pt;width: 28cm;margin: 0 auto;" class="table_ch">
            组团单位： {{stateItemInfo.tuxUnitName}}
          </p>
          <table cellspacing="0" cellpadding="0" style="border-collapse:collapse;width: 28cm;table-layout: fixed;margin: 0 auto">
            <thead>
            <tr>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr style="height:32pt">
              <td
                colspan="9"
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:4.65pt; padding-right:5.03pt; vertical-align:middle">
                <p style="margin:0pt; orphans:0; text-align:center; widows:0">
                  <span style="font-family:外交小标宋;font-size:10.5pt;">团组成员名单（姓名和单位职务）</span>
                </p>
              </td>
              <td
                colspan="7"
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:4.65pt; padding-right:5.03pt; vertical-align:middle">
                <p style="margin:0pt; orphans:0; text-align:center; widows:0">
                  <span style="font-family:外交小标宋;font-size:10.5pt;">在外停留时间（离抵境日期）</span>
                </p>
              </td>
              <td
                colspan="5"
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:4.65pt; padding-right:5.03pt; vertical-align:middle">
                <p style="margin:0pt; orphans:0; text-align:center; widows:0">
                  <span style="font-family:外交小标宋;font-size:10.5pt;">出访国家/地区</span>
                </p>
              </td>
              <td
                colspan="5"
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:4.65pt; padding-right:5.03pt; vertical-align:middle">
                <p style="margin:0pt; orphans:0; text-align:center; widows:0">
                  <span style="font-family:外交小标宋;font-size:10.5pt;">经停国家/地区</span>
                </p>
              </td>
              <td
                colspan="7"
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:4.65pt; padding-right:5.03pt; vertical-align:middle"
              >
                <p style="margin:0pt; orphans:0; text-align:center; widows:0">
                  <span style="font-family:外交小标宋;font-size:10.5pt;">是否擅自延长在外停留时间或变更出访日程</span>
                </p>
              </td>
              <td
                colspan="6"
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:4.65pt; padding-right:5.03pt; vertical-align:middle">
                <p style="margin:0pt; orphans:0; text-align:center; widows:0">
                  <span style="font-family:外交小标宋;font-size:10.5pt;">是否安排打前站或团外团</span>
                </p>
              </td>
              <td
                colspan="7"
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:4.65pt; padding-right:5.03pt; vertical-align:middle">
                <p style="margin:0pt; orphans:0; text-align:center; widows:0">
                  <span style="font-family:外交小标宋;font-size:10.5pt;">是否安排中资机构、留学生等迎送</span>
                </p>
              </td>
              <td
                colspan="7"
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:4.65pt; padding-right:5.03pt; vertical-align:middle">
                <p style="margin:0pt; orphans:0; text-align:center; widows:0">
                  <span style="font-family:外交小标宋;font-size:10.5pt;">是否安排超标准住房或乘坐交通工具</span>
                </p>
              </td>
              <td
                colspan="7"
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:4.65pt; padding-right:5.03pt; vertical-align:middle">
                <p style="margin:0pt; orphans:0; text-align:center; widows:0">
                  <span style="font-family:外交小标宋;font-size:10.5pt;">是否违规安排或接受宴请、旅游等活动</span>
                </p>
              </td>
              <td
                colspan="7"
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:4.65pt; padding-right:5.03pt; vertical-align:middle">
                <p style="margin:0pt; orphans:0; text-align:center; widows:0">
                  <span style="font-family:外交小标宋;font-size:10.5pt;">是否收受内部或外方礼品，如何处理</span>
                </p>
              </td>
            </tr>
            <tr style="height:32pt">
              <td
                colspan="9"
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:middle"
              >
                <div
                  style="white-space:normal; width:100%;font-family:外交小标宋;font-size: 10.5pt;border:none;outline:none;text-align: center;"
                  contentEditable="true">
                  <span v-for="(item, index) in personInfoList" :key="index">{{item.name}} {{item.duty}}<span v-if="personInfoList.length > 1">、</span></span>
                  <span v-if="personInfoList.length > 2">等{{personInfoList.length}}人</span>
                </div>
              </td>
              <td
                colspan="7"
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:middle"
              >
                <div
                  style="white-space:normal; width:100%;font-family:外交小标宋;font-size: 10.5pt;border:none;outline:none;text-align: center;"
                  contentEditable="true">
                  共{{stateItemInfo.outsideNum}}天，{{entrydate}}离境，{{depadate}}抵境
                </div>
              </td>
              <td
                colspan="5"
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:middle"
              >
                <div
                  style="white-space:normal; width:100%;font-family:外交小标宋;font-size: 10.5pt;border:none;outline:none;text-align: center;"
                  contentEditable="true">
                  {{stateItemInfo.visitCountryName}}
                </div>
              </td>
              <td
                colspan="5"
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:middle"
              >
                <div
                  style="white-space:normal; width:100%;font-family:外交小标宋;font-size: 10.5pt;border:none;outline:none;text-align: center;"
                  contentEditable="true">
                  {{stopoverArea}}
                </div>
              </td>
              <td
                colspan="7"
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:middle"
              >
                <div
                  style="white-space:normal; width:100%;font-family:外交小标宋;font-size: 10.5pt;border:none;outline:none;text-align: center;"
                  contentEditable="true">
                  <el-select v-model="value1" placeholder="">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </td>
              <td
                colspan="6"
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:middle"
              >
                <div
                  style="white-space:normal; width:100%;font-family:外交小标宋;font-size: 10.5pt;border:none;outline:none;text-align: center;"
                  contentEditable="true">
                  <el-select v-model="value2" placeholder="">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </td>
              <td
                colspan="7"
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:middle"
              >
                <div
                  style="white-space:normal; width:100%;font-family:外交小标宋;font-size: 10.5pt;border:none;outline:none;text-align: center;"
                  contentEditable="true">
                  <el-select v-model="value3" placeholder="">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </td>
              <td
                colspan="7"
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:middle"
              >
                <div
                  style="white-space:normal; width:100%;font-family:外交小标宋;font-size: 10.5pt;border:none;outline:none;text-align: center;"
                  contentEditable="true">
                  <el-select v-model="value4" placeholder="">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </td>
              <td
                colspan="7"
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:middle"
              >
                <div
                  style="white-space:normal; width:100%;font-family:外交小标宋;font-size: 10.5pt;border:none;outline:none;text-align: center;"
                  contentEditable="true">
                  <el-select v-model="value5" placeholder="">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </td>

              <td
                colspan="7"
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:middle"
              >
                <div
                  style="white-space:normal; width:100%;font-family:外交小标宋;font-size: 10.5pt;border:none;outline:none;text-align: center;"
                  contentEditable="true">
                  <el-select v-model="value6" placeholder="">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </div>
              </td>
            </tr>
            <tr style="height:32pt">
              <td
                colspan="6"
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:none; border-right-width:0pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:4.65pt; padding-right:5.03pt; vertical-align:middle">
                <p style="margin:0pt; orphans:0; text-align:left; widows:0; font-family:外交小标宋;font-size:10.5pt;">
                  填表日期：
                </p>
              </td>
              <td
                colspan="10"
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:none; border-left-width:0pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-right:5.03pt; vertical-align:middle">
                <p style="margin:0pt; orphans:0; text-align:left; widows:0; font-family:外交小标宋;font-size:10.5pt;">
                  <foreign-date-picker
                    style="border:none;outline:none;width: 100%"
                    v-model="currentTime"
                    value-format="yyyy-MM-dd"
                  ></foreign-date-picker>
                </p>
              </td>
              <td
                colspan="51"
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:4.65pt; padding-right:5.03pt; vertical-align:middle">
                <p style="margin:0pt; orphans:0; text-align:left; widows:0;font-family:外交小标宋;font-size:10.5pt;display: flex;">
                  <span>填表人及联系电话:</span>
                  <el-input v-model="stateItemInfo.loginName" style="width: 42%;" size="mini"></el-input>
                  <el-input v-model="stateItemInfo.loginPhone" style="width: 42%;" size="mini"></el-input>
                </p>
              </td>
            </tr>
            <tr style="height:64pt">
              <td
                colspan="67"
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:4.65pt; padding-right:5.03pt; vertical-align:middle">
                <p style="margin: -25pt 0pt 0pt 0pt; orphans:0; text-align:left; widows:0">
                  <span style="font-family:外交小标宋;font-size:10.5pt;"><span class="entire">全体</span>团员签字：</span>
                </p>
              </td>
            </tr>
            <tr style="height:64pt">
              <td
                colspan="67"
                style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:4.65pt; padding-right:5.03pt; vertical-align:middle">
                <p style="margin: 0pt 0pt 0pt; orphans:0; text-align:left; widows:0">
                  <span style="font-family:外交小标宋;font-size:10.5pt;">填表说明: </span>
                </p>
                <p style="margin: 0pt 0pt 0pt; orphans:0; text-align:left; widows:0">
                  <span style="font-family:外交小标宋;font-size:10.5pt;">1、表内所有栏目须如实填报，如无该项信息请填“无”；如“有”须作出说明；</span>
                </p>
                <p style="margin: 0pt; orphans:0; text-align:left; widows:0">
                  <span style="font-family:外交小标宋;font-size:10.5pt;">2、“在外停留时间”栏内容按“共X天，XXXX年XX月日离境，XXXX年XX月X日抵境”格式填写；</span>
                </p>
                <p style="margin: 0pt; orphans:0; text-align:left; widows:0">
                  <span style="font-family:外交小标宋;font-size:10.5pt;">3、“出访国家/地区”注明具体到访国家或地区名称；</span>
                </p>
                <p style="margin: 0pt; orphans:0; text-align:left; widows:0">
                  <span style="font-family:外交小标宋;font-size:10.5pt;">4、“经停国家/地区”指需办理出入境手续的经停国家或地区，不出机场中转的填写“无”；</span>
                </p>
                <p style="margin: 0pt; orphans:0; text-align:left; widows:0">
                  <span style="font-family:外交小标宋;font-size:10.5pt;">5、收受的礼品请注明馈赠方、礼品名称及如何处理；</span>
                </p>
                <p style="margin: 0pt; orphans:0; text-align:left; widows:0">
                  <span style="font-family:外交小标宋;font-size:10.5pt;">6、本表需全体团员签字确认。</span>
                </p>
              </td>
            </tr>
            </tbody>
          </table>
          <p
            style="orphans:0; text-align:left; widows:0;font-family:外交小标宋;font-size:12pt;width: 28cm;margin:10pt auto 0px auto;">
            外交部因公临时出国违规违纪举报电子信箱: chuguoweijijubao@mfa.gov.cn
          </p>
        </div>
      </div>
    </el-main>
    <el-footer>
      <div style="text-align:center">
        <span>版权所有：中国化学工程集团(股份)有限公司 | <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备17025820号-5</a> | 版本号：{{this.versionNumber}}<!-- | 技术支持：北京赛鼎科技有限公司 --></span>
      </div>
    </el-footer>
  </el-container>
</template>

<script>
  import printjs from "print-js";
  import {mapGetters} from "vuex";
  import SetupApi from "@/api/setup";
  import DateUtil from "@/util/date.js";
  export default {
    name: "usbkey_application_form",
    computed: {
      ...mapGetters(['userInfo', "versionNumber"]),
      depadate() {
        let info = this.stateItemInfo;
        let outsideNum = this.stateItemInfo.outsideNum;
        let preDepaDate = this.stateItemInfo.preDepaDate.slice(0,10);
        let date = new DateUtil().getDepartureDate(info, outsideNum, preDepaDate);
        return date ? this.conversionTimeFormat(date) : null;
      },
    },
    data() {
      return {
        isLoad: false,
        stateItemInfo: {},
        personInfoList: [],
        visitInfoList: [],
        entrydate: '',  // 离境时间
        // 是否选择
        options: [{
          value: '0',
          label: '是'
        }, {
          value: '1',
          label: '否'
        }],
        // 是否擅自延长在外停留时间或变更出访日程
        value1: '',
        // 是否安排打前站或团外团
        value2: '',
        // 是否安排中资机构、留学生等迎送
        value3: '',
        // 是否安排超标准住房或乘坐交通工具
        value4: '',
        // 是否违规安排或接受宴请、旅游等活动
        value5: '',
        // 是否收受内部或外方礼品，如何处理
        value6: '',
        // 经停地区
        stopoverArea: '',
        // 填表日期
        currentTime: '',
      };
    },
    created() {
      this.getCurrentTime();
    },
    methods: {
      // 转换时间格式
      conversionTimeFormat(dateString) {
        let pattern = /(\d{4})\-(\d{2})\-(\d{2})/;
        let str = dateString.replace(pattern, '$1年$2月$3日');
        return str;
      },
      getCurrentTime() {
        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        month = (month > 9) ? month : ("0" + month);
        day = (day < 10) ? ("0" + day) : day;
        let time = year + "-" + month + "-" + day;
        this.currentTime = time;
      },
      print() {
        printjs({
          type: "html",
          printable: "print",
          scanStyles: false,
          css: ["/static/print/usbkeyApplicationForm.css"]
        });
      },
      getData() {
        this.isLoad = true;
        let Api = new SetupApi();
        Api.getOverview({ itemInfoId: this.$route.query.id }).then(res => {
          console.log(res.data)
          this.stateItemInfo =  res.data.stateItemInfo;
          this.personInfoList = res.data.personInfoList;
          this.entrydate = this.conversionTimeFormat(this.stateItemInfo.preDepaDate.slice(0,10));
          this.isLoad = false;
        });
      }
    },
    mounted() {
      // 初始化打印页面
      if (this.$route.query.id) {
        this.getData();
      }
    }

  }
</script>

<style scoped>
  /*这样打印还是不会生效，要把样式写入@media print {}中，并且不能用嵌套写，只能用普通的css写法，这样问题就解决了*/
  .entire {
    font-weight: bolder;
  }

  /deep/ .el-input__icon {
    display: none;
  }

  /deep/ .el-input--prefix .el-input__inner {
    padding: 0;
  }

  /deep/ .el-select .el-input {
    border-radius: 0px;
    border: none;
  }

  #print table td input {
    border: 0px solid transparent;
    width: 95%;
    height: 18pt;
    font-size: 12pt;
    text-align: center;
    box-sizing: border-box;
    outline: none;
    line-height: 41px;
  }
</style>
